/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemUnsupportedMediaType } from './ProblemUnsupportedMediaType';

export const UnsupportedMediaTypeProblems: core.serialization.Schema<
    serializers.UnsupportedMediaTypeProblems.Raw,
    Truvity.UnsupportedMediaTypeProblems
> = core.serialization
    .union('type', {
        '/unsupported-media-type': ProblemUnsupportedMediaType,
    })
    .transform<Truvity.UnsupportedMediaTypeProblems>({
        transform: (value) => value,
        untransform: (value) => value,
    });

export declare namespace UnsupportedMediaTypeProblems {
    export type Raw = UnsupportedMediaTypeProblems.UnsupportedMediaType;

    export interface UnsupportedMediaType extends ProblemUnsupportedMediaType.Raw {
        type: '/unsupported-media-type';
    }
}
